import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Plane, Home as HomeIcon, ClipboardCheck, ShieldCheck, MessageCircle, GraduationCap, Users, Phone, HeartHandshake } from 'lucide-react';
import PageHero, { Section, InfoCard, CTABlock } from '../components/PageHero';

const services = [
  { icon: MessageCircle, title: 'Free Counselling', desc: '1-on-1 sessions with salaried counsellors to understand your NEET score, budget, and university fit.' },
  { icon: ClipboardCheck, title: 'Eligibility Assessment', desc: 'On-the-spot NEET score & academic transcript verification to shortlist the best universities for you.' },
  { icon: FileText, title: 'Document Preparation', desc: 'Complete apostille support for 10th/12th mark sheets, birth certificate, passport & NEET scorecard.' },
  { icon: GraduationCap, title: 'Direct Admissions', desc: 'Direct enrollment in 64+ government universities with no capitation fee or middlemen markup.' },
  { icon: Plane, title: 'Visa Support', desc: 'End-to-end Russian student visa assistance including invitation letter and biometric coordination.' },
  { icon: HomeIcon, title: 'Pre-Departure Briefing', desc: 'Detailed guidance on flights, luggage, currency, medical checkup and cultural preparation.' },
  { icon: Users, title: 'Airport Pickup & Hostel Setup', desc: 'Local on-ground teams welcome you at the airport and help with hostel check-in, SIM & bank account.' },
  { icon: ShieldCheck, title: 'Post-Arrival Support', desc: 'Continuous student support throughout the 6-year MBBS — academic, medical & emotional.' },
  { icon: HeartHandshake, title: 'FMGE / NExT Coaching', desc: 'Partnerships with top FMGE / NExT coaching institutes for guaranteed post-graduation prep.' },
];

export default function Services() {
  return (
    <>
      <PageHero eyebrow="What We Do" title="Our" highlight="Services"
        subtitle="9 core services covering every step of your MBBS journey — from the first counselling call to your final year internship in Russia."
        breadcrumbs={[{ label: 'Services' }]} />

      <Section eyebrow="End-to-End Support" title="9 Services, One" highlight="Trusted Partner">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => <InfoCard key={i} icon={s.icon} title={s.title}>{s.desc}</InfoCard>)}
        </div>
      </Section>

      <Section eyebrow="Timeline" title="How Long Does" highlight="Each Step Take?" muted>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { t: 'Counselling & Selection', d: '1–3 days' },
            { t: 'Document Apostille', d: '10–15 days' },
            { t: 'Invitation Letter', d: '2–4 weeks' },
            { t: 'Student Visa', d: '10–15 days' },
          ].map((s, i) => (
            <div key={i} className="bg-white rounded-2xl border border-border p-5 text-center">
              <div className="font-serif text-2xl font-bold text-brand">{s.d}</div>
              <div className="mt-1 text-sm text-primary font-semibold">{s.t}</div>
            </div>
          ))}
        </div>
      </Section>

      <CTABlock title="Start your admission journey today" subtitle="Every service listed above is FREE for admitted students. No hidden charges." cta="Book Free Consultation" />
    </>
  );
}
